import React, { Component } from 'react';
import CoursesCard from "../../../../../../dashboardNew/components/cards/CoursesCard";

class CourseList extends Component {
    render() {
        const coursesList = this.props.courses.coursesList;

        return (
            <div className="row">
                {
                    coursesList && coursesList.length > 0 && coursesList.map((course, index) => {
                        return (
                            <CoursesCard
                                key={index}
                                coursesData={course}
                            />
                        );
                    })
                }
            </div>
        );
    };
}

export default CourseList;



// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/elements/CourseList.js